/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptions, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptionsFromJSONTyped, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptionsToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptions';
export function FxIdWebFeaturesStoreCreatePaymentRequestSteamFromJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestSteamFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestSteamFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptions(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesStoreCreatePaymentRequestSteamToJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestSteamToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestSteamToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptions(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesStoreCreatePaymentRequestSteam.js.map